var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dark_check",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16.71 16.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d9d9d9;}.cls-1,.cls-2{stroke-width:0px;}.cls-3{mask:url(#mask);}.cls-2{fill:#2a2a2a;}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: -1.67,
    y: -1.67,
    width: 20,
    height: 20,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask0_2625_221"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -1.67,
    y: -1.67,
    width: 20,
    height: 20
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.17,9.83l-1.79-1.79c-.15-.15-.35-.23-.58-.23s-.43.08-.58.23c-.15.15-.23.35-.23.58s.08.43.23.58l2.38,2.37c.17.17.36.25.58.25s.42-.08.58-.25l4.71-4.71c.15-.15.23-.35.23-.58s-.08-.43-.23-.58c-.15-.15-.35-.23-.58-.23s-.43.08-.58.23l-4.13,4.13ZM8.33,16.67c-1.15,0-2.24-.22-3.25-.66-1.01-.44-1.9-1.03-2.65-1.78-.75-.75-1.34-1.63-1.78-2.65-.44-1.01-.66-2.1-.66-3.25s.22-2.24.66-3.25c.44-1.01,1.03-1.9,1.78-2.65.75-.75,1.63-1.34,2.65-1.78,1.01-.44,2.1-.66,3.25-.66s2.24.22,3.25.66c1.01.44,1.9,1.03,2.65,1.78.75.75,1.34,1.63,1.78,2.65.44,1.01.66,2.1.66,3.25s-.22,2.24-.66,3.25c-.44,1.01-1.03,1.9-1.78,2.65s-1.63,1.34-2.65,1.78c-1.01.44-2.1.66-3.25.66Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleDark);
export default __webpack_public_path__ + "static/media/check-circle-dark.77f7adb8b7ae2331a84181e2933ea2bc.svg";
export { ForwardRef as ReactComponent };